import type { EditorState } from '../../store/editorState';

const didVisitMobileEditorInCurrentSession = (state: EditorState) =>
  state.mobile.didVisitMobileEditorInCurrentSession;

export { didVisitMobileEditorInCurrentSession };
